import XdslLineIntentionPopin from "../../../../common/broadband/components/XdslLineIntentionPopin.vue";
import CartRecovery from "./components/CartRecovery.vue";
import EligibilityBanner from "./components/EligibilityBanner.vue";
import NewInternetOfferTile from "./components/NewInternetOfferTile.vue";
import OffersTabs from "./components/OffersTabs.vue";
import DiscountedInternetOfferTile from "./components/DiscountedInternetOfferTile.vue";
import InternetOfferDetails from "./components/InternetOfferDetails.vue";
import {alignDivsHeightsByLine} from "../../utils/AlignDivHeightsUtil";
import GenericButtonCta from "../../../../common/broadband/components/GenericButtonCta.vue";
import OffersAnimationSection from "../../../../common/components/vue/animation/OffersAnimationSection.vue";
import Banner from "../../../../fmfmo/common/components/Banner.vue";
import BrandAnimationSection from "../../../../fmfmo/common/fragments/BrandAnimationSection.vue";
import PriceDetailsPopin from "../../../../fmfmo/acquisition/vitrine/fragments/PriceDetailsPopin.vue";

const listOfDivToAlign = [
    "tag-timer", "title-align", "title-price-align", "debit",
    "internet-secondary", "cross-discount-banner",
    "base-price-wrapper", "final-price-wrapper", "price-wrapper", "price-align",
    "offer-edito-content", "mobileprice-odrmention-align", "detail-link-align", "cart-item-status-align",
    "keywords-align"
];
const listOfCollapsibleDivToAlign = [
    "media-body-description-0", "media-body-description-1",
    "media-body-description-2", "media-body-description-3", "media-body-description-4", "media-body-description-5"
];

const root = document.getElementById("internet-offers-main");

window.app = new Vue({
    el: root,
    name: "InternetOffersMain",
    components: {
        XdslLineIntentionPopin,
        CartRecovery,
        EligibilityBanner,
        DiscountedInternetOfferTile,
        NewInternetOfferTile,
        OffersTabs,
        GenericButtonCta,
        OffersAnimationSection,
        BrandAnimationSection,
        InternetOfferDetails,
        Banner,
        PriceDetailsPopin,
    },
    data() {
        return {
            dto: dto,
            selectedInternetOffersTiles: null,
            displayedInternetOffersTiles: [],
            displayedOffersAnimation: null,
            displayedInternetOffersAnimationsTiles: null,
            displayedInternetMobileAtHomeOffersTiles: null,
            displayedAlternativeOffersTiles: null,
            showTabs: dto.tabs != null,
            showAttributes: false,
            showMobileClientOffers: false,
            offersType: dto.offersType,
            toggleAttributesBtnLabel: dto.showAttributesBtnLabel,
            toggleAttributesBtnTms: dto.showAttributesBtnTms,
            showAttributesBtnTms: dto.showAttributesBtnTms,
            hideAttributesBtnTms: dto.hideAttributesBtnTms,
            showAttributesBtnLabel: dto.showAttributesBtnLabel,
            hideAttributesBtnLabel: dto.hideAttributesBtnLabel,
            showDetailPage: dto.showOfferDetailPage,
            showDetailPageBtnLabel: dto.showOfferDetailPageBtnLabel,
            offersOffset: 0,
        }
    },
    computed: {
        nonEmptyTabs() {
            if (this.dto.tabs != null) {
                const tabsList = Array.isArray(this.dto.tabs?.tabsList) ? this.dto.tabs.tabsList : [];
                return tabsList.filter(el => (el.offers || []).length > 0);
            } else {
                return [];
            }
        },
        offersLengthByTabs() {
            if (this.dto.tabs != null) {
                return this.nonEmptyTabs.map(el => (el.offers || []).length)
            }
            else {
                return [];
            }
        },
        hasEmptyTabs() {
            return this.nonEmptyTabs.length === 0;
        },
        internetOffersTiles() {
            if (this.dto?.offers) {
                return this.dto.offers;
            } else {
                return [];
            }
        },
        brandAnimation() {
            if (this.dto?.brandAnimation) {
                return this.dto.brandAnimation;
            } else {
                return [];
            }
        },
        selectedInternetOfferSeoId() {
            if ((this.internetOffersTiles) && ((this.internetOffersTiles.length > 0))) {
                return this.internetOffersTiles[0].seoId;
            } else {
                return undefined;
            }
        },
        offersAnimation() {
            if (this.dto?.offersAnimation) {
                return this.dto.offersAnimation;
            } else {
                return null;
            }
        },
        leftTabOffersAnimation() {
            if (this.dto?.leftTabOffersAnimation) {
                return this.dto.leftTabOffersAnimation;
            } else {
                return null;
            }
        },
        rightTabOffersAnimation() {
            if (this.dto?.rightTabOffersAnimation) {
                return this.dto.rightTabOffersAnimation;
            } else {
                return null;
            }
        },
        internetMobileAtHomeOffersTiles() {
            if (this.dto?.mobileAtHomeOffers) {
                return this.dto.mobileAtHomeOffers;
            } else {
                return [];
            }
        },
        alternativeOffersTiles() {
            if (this.dto?.alternativeOffers) {
                return this.dto.alternativeOffers;
            } else {
                return [];
            }
        },
        showMoreOrLessOffersButton() {
            return this.selectedInternetOffersTiles !== null
            && this.selectedInternetOffersTiles.length > 3
            && this.displayedInternetOffersTiles !== null
        },
        showMoreOffersButton() {
            return this.showMoreOrLessOffersButton
                && this.displayedInternetOffersTiles.length < this.selectedInternetOffersTiles.length;
        },
        showLessOffersButton() {
            return this.showMoreOrLessOffersButton
                && this.displayedInternetOffersTiles.length >= this.selectedInternetOffersTiles.length;
        },
        showDiscountedInternetOfferTile() {
            return this.dto.offersAttributes != null && !this.showMoreOffersButton;
        },
        hasAlternativeOffers() {
            return this.displayedAlternativeOffersTiles && this.displayedAlternativeOffersTiles.length > 0;
        },
        hasInternetMobileAtHomeOffers() {
            return this.displayedInternetMobileAtHomeOffersTiles && this.displayedInternetMobileAtHomeOffersTiles.length > 0;
        },
        showDiscountedOfferTileWithOffers() {
            return (this.displayedInternetOffersTiles?.length || 0) > 1 && this.showDiscountedInternetOfferTile;
        },
        showDiscountedOfferTileWithAlternativeOffers() {
            return (this.displayedInternetOffersTiles?.length || 0) === 1 && this.showDiscountedInternetOfferTile;
        },
        isSingleOffer() {
            return this.dto?.singleOfferDetails && this.displayedInternetOffersTiles[0];
        },
        eligibilityUrl() {
            if (this.isSingleOffer && this.dto?.showBlocEligibility !== true) {
                return this.displayedInternetOffersTiles[0].genericButtonCta.actionUrl;
            } else {
                return undefined;
            }
        },
    },
    mounted() {
        this.addEventListerOnMenuFibreAdsl();
        this.selectInternetOffersTilesList();
        if (this.dto.showAllOffers) {
            this.sliceMoreOffersSegments();
        }
        this.alignDivs(listOfDivToAlign);
        this.addElementsForModalToggle();
        this.addEventListerOnLiveboxPopinMenu();
        window.addEventListener("resize", this.resizeWindow);
        window.addEventListener("hashchange", this.selectInternetOffersTilesList);
        this.$nextTick(() => {
            this.$refs.offersRef?.classList?.remove('not-mounted');
        });
    },
    updated() {
        this.alignDivs(listOfDivToAlign);
        this.addElementsForModalToggle();
    },
    methods: {
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash
        },
        getElementByXpath(path) {
            return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        },
        addElementsForModalToggle() {
            document.querySelectorAll(".offer-edito-content").forEach(
                function (edito) {
                    const {oeventCategory, oeventLabel} = edito.dataset;

                    edito.querySelectorAll("a").forEach(
                        function (link) {
                            link.classList.add("fw-bold");
                            const hrefAttr = link.getAttribute("href");
                            if (hrefAttr.startsWith("#")) {
                                link.target = "_self";
                                link.dataset.bsToggle = "modal";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = oeventLabel;
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            } else {
                                link.target = "_blank";
                            }
                        }
                    );
                }
            );
        },
        addEventListerOnLiveboxPopinMenu() {
            document.querySelectorAll(".livebox-multi-tab1").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        document.getElementById('tab1').classList.remove('d-none');
                        document.getElementById('tab2').classList.add('d-none')
                    }, false)
                }
            );
            document.querySelectorAll(".livebox-multi-tab2").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        document.getElementById('tab2').classList.remove('d-none');
                        document.getElementById('tab1').classList.add('d-none');
                    }, false)
                }
            );
        },
        addEventListerOnMenuFibreAdsl() {
            document.querySelectorAll(".menu-fibre-adsl").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        window.location.href = element.href
                    }, false)
                }
            );
        },
        toggleAttributes() {
            this.showAttributes = !this.showAttributes;
            if (this.showAttributes) {
                this.toggleAttributesBtnLabel = this.hideAttributesBtnLabel
                this.toggleAttributesBtnTms = this.hideAttributesBtnTms
                setTimeout(() => {
                    this.resizeCollapsibleDivToAlign()
                }, 100);
                window.addEventListener("resize", this.resizeCollapsibleDivToAlign)
            } else {
                this.toggleAttributesBtnLabel = this.showAttributesBtnLabel
                this.toggleAttributesBtnTms = this.showAttributesBtnTms
                window.removeEventListener("resize", this.resizeCollapsibleDivToAlign)
            }
        },
        resetToggleAttributes() {
            this.showAttributes = false;
            this.toggleAttributesBtnLabel = this.showAttributesBtnLabel
            this.toggleAttributesBtnTms = this.showAttributesBtnTms
            window.removeEventListener("resize", this.resizeCollapsibleDivToAlign)
        },
        resizeWindow() {
            const wasShowingAllOffers = this.offersOffset > 0
                && this.offersOffset >= (this.selectedInternetOffersTiles?.length || 0);
            this.selectInternetOffersTilesList();
            if (wasShowingAllOffers) {
                this.showAllSelectedOffers();
            }
            this.alignDivs(listOfDivToAlign);
        },
        resizeCollapsibleDivToAlign() {
            this.alignDivs(listOfCollapsibleDivToAlign);
        },
        alignDivs(divsToAlign) {
            alignDivsHeightsByLine(divsToAlign);
        },

        selectInternetOffersTilesList() {
            // Si on a des onglets à afficher et que en fonction de la résolution on a plus de 2 offres ou 4 offres
            if (this.dto.tabs != null) {

                // si aucun onglet n'est disponible, on charge la liste des offres par défaut
                if (this.hasEmptyTabs) {
                    this.loadAllOffersByDefault();
                }
                // sinon, on charge les onglets avec leurs offres
                else {
                    const hasOneTabOnlyOneOffer = this.offersLengthByTabs.find(el => el === 1) != null;

                    // Si en fonction de la résolution, on a plus de 1 offre ou 2 offres minimum par onglet, alors on affiche les onglets
                    if ((window.innerWidth < 736) ||
                        (window.innerWidth >= 736 && !hasOneTabOnlyOneOffer)
                    ) {
                        // Pas de hashtag, on charge les offres du premier onglet par défaut
                        if (this.readHash() === "") {
                            this.loadFirstTab();
                        }
                        // On a un hashtag, on le contrôle et on charge les offres de l'onglet correspondant uniquement
                        else {
                            let hashTagOK = false;
                            this.nonEmptyTabs.forEach(
                                (el) => {
                                    if (el.id === this.readHash()) {
                                        this.toggleTab({tab: el.id});
                                        hashTagOK = true;
                                    }
                                }
                            )
                            // si hashtag inconnu des id des tabs on le reset
                            if (!hashTagOK) {
                                this.loadFirstTab();
                            }
                        }
                        this.showTabs = true
                    }
                    // Sinon, on masque les onglets et on charge les offres de tous les onglets
                    else {
                        this.loadAllTabsOffers();
                    }
                }
            }
            // si pas d'onglets à afficher, on charge toutes les offres par defaut
            else {
                this.loadAllOffersByDefault();
            }
        },
        loadAllTabsOffers() {
            this.showTabs = false;
            this.offersOffset = 0;
            this.selectedInternetOffersTiles = this.nonEmptyTabs.flatMap(el => el.offers || []);
            this.displayedOffersAnimation = this.offersAnimation;
            this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
            this.sliceMoreOffersSegments();
        },
        loadAllOffersByDefault() {
            this.showTabs = false;
            this.offersOffset = 0;
            this.selectedInternetOffersTiles = this.internetOffersTiles;
            this.displayedOffersAnimation = this.offersAnimation;
            this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
            this.sliceMoreOffersSegments();
        },
        loadFirstTab() {
            this.offersOffset = 0;
            this.selectedInternetOffersTiles = this.nonEmptyTabs[0]?.offers || [];
            this.displayedOffersAnimation = this.leftTabOffersAnimation;
            this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
            this.displayedAlternativeOffersTiles = this.alternativeOffersTiles;
            this.sliceMoreOffersSegments();
        },
        toggleTab(selectedTab) {
            if (!this.dto.showAllOffers) {
                this.offersOffset = 0;
            }

            // Si on a des onglets, on les parcourt pour charger les offres de l'onglet sélectionné
            if (this.dto.tabs != null) {
                const selectedTabContent = this.nonEmptyTabs.find(el => selectedTab.tab === el.id);

                if (selectedTabContent != null) {
                    this.selectedInternetOffersTiles = selectedTabContent.offers || [];
                } else {
                    this.selectedInternetOffersTiles = [];
                }

                if (selectedTab.tab === this.nonEmptyTabs[0]?.id) {
                    this.displayedOffersAnimation = this.leftTabOffersAnimation;
                    this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
                    this.displayedAlternativeOffersTiles = this.alternativeOffersTiles;
                } else {
                    this.displayedOffersAnimation = this.rightTabOffersAnimation;
                    this.displayedInternetMobileAtHomeOffersTiles = [];
                    this.displayedAlternativeOffersTiles = [];
                }
            }
            this.sliceMoreOffersSegments();
        },
        sliceMoreOffersSegments() {
            if (this.offersOffset < this.selectedInternetOffersTiles.length) {
                if (this.offersOffset === 0 && this.selectedInternetOffersTiles.length > 3) {
                    this.offersOffset = 3;
                } else {
                    this.offersOffset = this.selectedInternetOffersTiles.length;
                }
            }
            this.displayedInternetOffersTiles = this.selectedInternetOffersTiles.slice(0, this.offersOffset);
            return this.displayedInternetOffersTiles;
        },
        sliceLessOffersSegments() {
            if (this.offersOffset < 0) {
                return
            }
            this.displayedInternetOffersTiles = this.selectedInternetOffersTiles.slice(0, 3);
            this.offersOffset = 3;
            return this.displayedInternetOffersTiles;
        },
        showAllSelectedOffers() {
            this.offersOffset = this.selectedInternetOffersTiles.length;
            this.displayedInternetOffersTiles = this.selectedInternetOffersTiles.slice(0, this.offersOffset);
            return this.displayedInternetOffersTiles;
        },
    }
});
